import { rifledCategoryURL, smoothboreCategoryURL } from "../config.js";
import icons from "url:../../images/sprite.svg";

export const weaponRowTemplate = ({
  data: obj,
  class: className,
  index: index,
  column: [
    col6,
    col7,
    col8,
    col9,
    col10,
    col11,
    col12,
    col13,
    col14,
    col15,
    col16,
    col17,
    col18,
    col19,
    col20,
    col21,
    col22,
    col23,
    col24,
  ],
  editble: editble,
  type: location,
}) => {
  const category = location;
  const type = category === smoothboreCategoryURL ? "2" : "1";
  const mainRowActionBtnsHTML = `
    <div class="trow-data-icons ${editble ? "hidden" : ""} icons-first">
        <div class="trow-data__icon drag-item" title="Переместить">
            <svg class="wd-icon">
                <use xlink:href="${icons}#drag"></use>
            </svg>
        </div>
        <div class="trow-data__icon edit-item" title="Редактировать">
            <svg class="wd-icon">
                <use xlink:href="${icons}#edit"></use>
            </svg>
        </div>
        <div class="trow-data__icon add-sub-item" title="Добавить ствол">
            <svg class="wd-icon">
                <use xlink:href="${icons}#add"></use>
            </svg>
        </div>
    </div>
    <div class="trow-data-icons ${editble ? "" : "hidden"} icons-second">
        <div class="trow-data__icon save-item" title="Сохранить">
            <svg class="wd-icon">
                <use xlink:href="${icons}#save"></use>
            </svg>
        </div>
        <div class="trow-data__icon delete-item" title="Удалить">
            <svg class="wd-icon">
                <use xlink:href="${icons}#delete"></use>
            </svg>
        </div>
    </div>
    `;
  const subRowActionBtnsHTML = `
    <div class="trow-data-icons icons-first ${editble ? "hidden" : ""}">
        <div class="trow-data__icon edit-item" title="Редактировать">
            <svg class="wd-icon">
                <use xlink:href="${icons}#edit"></use>
            </svg>
        </div>
    </div>
    <div class="trow-data-icons icons-second ${editble ? "" : "hidden"}">
        <div class="trow-data__icon save-item" title="Сохранить">
            <svg class="wd-icon">
                <use xlink:href="${icons}#save"></use>
            </svg>
        </div>
        <div class="trow-data__icon delete-item" title="Удалить">
            <svg class="wd-icon">
                <use xlink:href="${icons}#delete"></use>
            </svg>
        </div>
    </div>
    `;

  let smoothboreColumns = "";
  let rifledColumns = "";

  if (category === smoothboreCategoryURL) {
    smoothboreColumns = `
        <div class="trow-data data-col col-8 ${
          col8?.open === undefined || col8?.open ? "" : "hidden"
        }" data-collapsible="8">
            <select name="bulletLength" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.bulletLength === "" ? "selected" : ""}>--</option>
                <option value="70" ${obj?.bulletLength === "70" ? "selected" : ""}>70</option>
                <option value="76" ${obj?.bulletLength === "76" ? "selected" : ""}>76</option>
            </select>
        </div>
        <div class="trow-data data-col col-9 ${
          col9?.open === undefined || col9?.open ? "" : "hidden"
        }" data-collapsible="9">
            <input type="text" name="barrelLength" value="${obj.barrelLength || ""}" ${
      editble ? "" : "readonly"
    }>
        </div>
        `;
  }
  if (category === rifledCategoryURL) {
    rifledColumns = `
        <div class="trow-data data-col col-24 ${
          col24?.open === undefined || col24?.open ? "" : "hidden"
        }" data-collapsible="24">
            <input type="text" name="aim" value="${obj.aim || ""}" ${editble ? "" : "readonly"}>
        </div>
        `;
  }
  const weaponRowHTML = `
    <div class="${className} trow-line ${editble ? "editble" : ""}">
        <div class="trow-data-fixed">
        <div class="trow-data actions-column col-1">
            ${className === "trow-main" ? mainRowActionBtnsHTML : subRowActionBtnsHTML}
        </div>
        <div class="trow-data hidden">
            <input type="text" name="id" value="${obj.id || ""}">
        </div>
        <div class="trow-data hidden">
            <input type="text" name="parent_id" value="${obj.parent_id || "0"}">
        </div>
        <div class="trow-data hidden">
            <input type="text" name="type" value="${obj.type || type}">
        </div>
        <div class="trow-data hidden">
            <input type="number" name="public" value="${obj.public || "1"}">
        </div>
        <div class="trow-data col-2">
            <input type="text" name="position" value="${obj.position}${
    index ? `.${index}` : ""
  }" readonly>
        </div>
        <div class="trow-data col-3">
            <input type="text" name="numberRX" value="${obj.numberRX || ""}" readonly>
        </div>
        <div class="trow-data col-4">
            <input type="text" name="manufacturer" value="${obj.manufacturer || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data col-5">
        ${
          editble
            ? `<input type="text" name="name" value="">`
            : `<a href="/${obj.id}" class="trow-link">${obj.name}</a>`
        }
            <div class="trow-data-error-mes">Введите название</div>
        </div>
    </div>
    <div class="trow-data-scroll">
        <div class="trow-data data-col col-6 ${
          col6?.open || col6?.open === undefined ? "" : "hidden"
        }" data-collapsible="6">
            <select name="subtype" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.subtype === "" ? "selected" : ""}>--</option>
                <option value="Двустольное вертикальное" ${
                  obj?.subtype === "Двустольное вертикальное" ? "selected" : ""
                }>Двуст. вертикальное</option>
                <option value="Двустольное горизонтальное" ${
                  obj?.subtype === "Двустольное горизонтальное" ? "selected" : ""
                }>Двуст. горизонтальное</option>
                <option value="Полуавтомат" ${
                  obj?.subtype === "Полуавтомат" ? "selected" : ""
                }>Полуавтомат</option>
                <option value="Помповое" ${
                  obj?.subtype === "Помповое" ? "selected" : ""
                }>Помповое</option>
                <option value="Карабин" ${
                  obj?.subtype === "Карабин" ? "selected" : ""
                }>Карабин</option>
                <option value="Штуцер" ${
                  obj?.subtype === "Штуцер" ? "selected" : ""
                }>Штуцер</option>
                <option value="Комбинированное" ${
                  obj?.subtype === "Комбинированное" ? "selected" : ""
                }>Комбинированное</option>
            </select>
        </div>
        <div class="trow-data data-col col-7 ${
          col7?.open === undefined || col7?.open ? "" : "hidden"
        }" data-collapsible="7">
            <input type="text" name="caliber" value="${obj.caliber || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        ${rifledColumns}
        ${smoothboreColumns}
        <div class="trow-data data-col col-10 ${
          col10?.open === undefined || col10?.open ? "" : "hidden"
        }" data-collapsible="10">
            <select name="trigger" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.trigger === "" ? "selected" : ""}>--</option>
                <option value="1" ${obj?.trigger === 1 ? "selected" : ""}>1</option>
                <option value="2" ${obj?.trigger === 2 ? "selected" : ""}>2</option>
            </select>
        </div>
        <div class="trow-data data-col col-11 ${
          col11?.open === undefined || col11?.open ? "" : "hidden"
        }" data-collapsible="11">
            <input type="text" name="purchasePrice" value="${obj.purchasePrice || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data data-col col-12 ${
          col12?.open === undefined || col12?.open ? "" : "hidden"
        }" data-collapsible="12">
            <input type="text" name="marketPrice" value="${obj.marketPrice || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data data-col col-13 ${
          col13?.open === undefined || col13?.open ? "" : "hidden"
        }" data-collapsible="13">
            <input type="text" name="weaponNumber" value="${obj.weaponNumber || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data data-col col-14 ${
          col14?.open === undefined || col14?.open ? "" : "hidden"
        }" data-collapsible="14">
            <select name="case" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.case === "" ? "selected" : ""}>--</option>
                <option value="Нету" ${obj?.case === "Нету" ? "selected" : ""}>Нету</option>
                <option value="Кейс" ${obj?.case === "Кейс" ? "selected" : ""}>Кейс</option>
                <option value="Дерево" ${
                  obj?.case === "Дерево" ? "selected" : ""
                }>Дерево</option>
            </select>
        </div>
        <div class="trow-data data-col col-15 ${
          col15?.open === undefined || col15?.open ? "" : "hidden"
        }" data-collapsible="15">
            <input type="text" name="term" value="${obj.term || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data data-col col-16 ${
          col16?.open === undefined || col16?.open ? "" : "hidden"
        }" data-collapsible="16">
            <select name="passport" ${editble ? "" : "disabled"}>
                <option value="0" ${obj?.passport === 0 ? "selected" : ""}>Нету</option>
                <option value="1" ${obj?.passport === 1 ? "selected" : ""}>Есть</option>
            </select>
        </div>
        <div class="trow-data data-col col-17 ${
          col17?.open === undefined || col17?.open ? "" : "hidden"
        }" data-collapsible="17">
            <input type="number" name="productionYear" value="${obj.productionYear || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data data-col col-22 ${
          col22?.open === undefined || col22?.open ? "" : "hidden"
        }" data-collapsible="22">
            <select name="weaponCondition" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.weaponCondition === "" ? "selected" : ""}>--</option>
                <option value="1" ${obj?.weaponCondition === 1 ? "selected" : ""}>1</option>
                <option value="2" ${obj?.weaponCondition === 2 ? "selected" : ""}>2</option>
                <option value="3" ${obj?.weaponCondition === 3 ? "selected" : ""}>3</option>
                <option value="4" ${obj?.weaponCondition === 4 ? "selected" : ""}>4</option>
                <option value="5" ${obj?.weaponCondition === 5 ? "selected" : ""}>5</option>
            </select>
        </div>
        <div class="trow-data data-col col-23 ${
          col23?.open === undefined || col23?.open ? "" : "hidden"
        }" data-collapsible="23">
            <select name="barrelCondition" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.barrelCondition === "" ? "selected" : ""}>--</option>
                <option value="Идеальное" ${
                  obj?.barrelCondition === "Идеальное" ? "selected" : ""
                }>Идеальное</option>
                <option value="Хорошее" ${
                  obj?.barrelCondition === "Хорошее" ? "selected" : ""
                }>Хорошее</option>
                <option value="Сыпь" ${
                  obj?.barrelCondition === "Сыпь" ? "selected" : ""
                }>Сыпь</option>
                <option value="Раковина" ${
                  obj?.barrelCondition === "Раковина" ? "selected" : ""
                }>Раковина</option>
            </select>
        </div>
        <div class="trow-data data-col col-18 ${
          col18?.open === undefined || col18?.open ? "" : "hidden"
        }" data-collapsible="18">
            <select name="shelfNumber" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.shelfNumber === "" ? "selected" : ""}>--</option>
                <option value="1" ${obj?.shelfNumber === 1 ? "selected" : ""}>1</option>
                <option value="2" ${obj?.shelfNumber === 2 ? "selected" : ""}>2</option>
                <option value="3" ${obj?.shelfNumber === 3 ? "selected" : ""}>3</option>
                <option value="4" ${obj?.shelfNumber === 4 ? "selected" : ""}>4</option>
                <option value="5" ${obj?.shelfNumber === 5 ? "selected" : ""}>5</option>
                <option value="6" ${obj?.shelfNumber === 6 ? "selected" : ""}>6</option>
                <option value="7" ${obj?.shelfNumber === 7 ? "selected" : ""}>7</option>
                <option value="8" ${obj?.shelfNumber === 8 ? "selected" : ""}>8</option>
                <option value="9" ${obj?.shelfNumber === 9 ? "selected" : ""}>9</option>
                <option value="10" ${obj?.shelfNumber === 10 ? "selected" : ""}>10</option>
                <option value="11" ${obj?.shelfNumber === 11 ? "selected" : ""}>11</option>
                <option value="12" ${obj?.shelfNumber === 12 ? "selected" : ""}>12</option>
                <option value="13" ${obj?.shelfNumber === 13 ? "selected" : ""}>13</option>
                <option value="14" ${obj?.shelfNumber === 14 ? "selected" : ""}>14</option>
                <option value="15" ${obj?.shelfNumber === 15 ? "selected" : ""}>15</option>
                <option value="16" ${obj?.shelfNumber === 16 ? "selected" : ""}>16</option>
                <option value="17" ${obj?.shelfNumber === 17 ? "selected" : ""}>17</option>
                <option value="18" ${obj?.shelfNumber === 18 ? "selected" : ""}>18</option>
            </select>
        </div>
        <div class="trow-data data-col col-19 ${
          col19?.open === undefined || col19?.open ? "" : "hidden"
        }" data-collapsible="19">
            <select name="safe" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.safe === "" ? "selected" : ""}>--</option>
                <option value="1" ${obj?.safe === 1 ? "selected" : ""}>С-1</option>
                <option value="2" ${obj?.safe === 2 ? "selected" : ""}>С-2</option>
                <option value="3" ${obj?.safe === 3 ? "selected" : ""}>С-3</option>
                <option value="4" ${obj?.safe === 4 ? "selected" : ""}>С-4</option>
                <option value="5" ${obj?.safe === 5 ? "selected" : ""}>С-5</option>
                <option value="6" ${obj?.safe === 6 ? "selected" : ""}>С-6</option>
                <option value="7" ${obj?.safe === 7 ? "selected" : ""}>С-7</option>
            </select>
        </div>
        <div class="trow-data data-col col-20 ${
          col20?.open === undefined || col20?.open ? "" : "hidden"
        }" data-collapsible="20">
            <input type="text" name="choki" value="${obj.choki || ""}" ${
    editble ? "" : "readonly"
  }>
        </div>
        <div class="trow-data data-col col-21 ${
          col21?.open === undefined || col21?.open ? "" : "hidden"
        }" data-collapsible="21">
            <select name="investEvaluation" ${editble ? "" : "disabled"}>
                <option value="" ${obj?.investEvaluation === "" ? "selected" : ""}>--</option>
                <option value="1" ${obj?.investEvaluation === "1" ? "selected" : ""}>1</option>
                <option value="2" ${obj?.investEvaluation === "2" ? "selected" : ""}>2</option>
                <option value="3" ${obj?.investEvaluation === "3" ? "selected" : ""}>3</option>
                <option value="4" ${obj?.investEvaluation === "4" ? "selected" : ""}>4</option>
                <option value="5" ${obj?.investEvaluation === "5" ? "selected" : ""}>5</option>
            </select>
        </div>
    </div>
    </div>                
    `;

  return weaponRowHTML;
};
